import { V1ListModelFamilyRequest, V1ModelType } from '@blk/portfolio-security-server/models';
import { PartnerQueryParamKey } from '@ddt-web/url';

export class PasApiParamUtil {
	public static createModelFamiliesParams(modelTypes: V1ModelType[], published: boolean = true,
		countryCode: string = 'USA', pageSize: number = 100, skipCache: boolean = false): V1ListModelFamilyRequest {
		let requestParams: V1ListModelFamilyRequest = {
			preview: !published,
			countryCode,
			modelTypes,
			pageSize,
			pageToken: '',
			skipCache
		};
		const parsedUrl = new URL(window.location.href);
		const testPartnerFirm = parsedUrl.searchParams.get(PartnerQueryParamKey.TEST_PARTNER_FIRM);
		requestParams = testPartnerFirm ? { ...requestParams, testPartnerFirm } : { ...requestParams };
		return requestParams;
	}
}
